export type DroppedElement = {
  id: string;
  label: string;
  originalId: string;
  component: string;
  order: number;
  bottomSectionConfig?: BottomSectionConfig;
};

export type BottomSectionValues = {
  isRequired?: boolean;
  isModifiableAfterApproval?: boolean;
};

export type BottomSectionConfig = {
  showRequired?: boolean;
  showModifiableAfterApproval?: boolean;
};

export type ComponentValue = {
  elementId: string;
  component: string;
  label: string;
  value: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  isModifiableAfterApproval?: boolean;
};

// Symbol for identifying dropped items
export const itemKey = Symbol('dropped-item');

export type Edge = 'top' | 'bottom';

// Drag state for dropped elements
export type DragState =
  | { type: 'idle' }
  | { type: 'preview'; container: Element | DocumentFragment }
  | { type: 'dragging' };

export type DroppedItemData = {
  [itemKey]: true;
  item: DroppedElement;
  index: number;
  instanceId: symbol;
};

export type FocusableCardHandle = {
  focus: () => void;
};

export type DraggedElementData = {
  id: string;
  label: string;
  type: string;
  component: string;
  bottomSectionConfig?: BottomSectionConfig;
};

export type EditableComponentProps = {
  label: string;
  isReadOnly?: boolean;
  value?: string;
  onRenderedValueChange?: (value: string) => void;
};

// File with an associated field ID for form submissions
export type FileWithId = File & {
  id: string;
};
